import React from "react";
import PropTypes from "prop-types";
import styles from "./SettingsList.scss";

export const Item = ({ title, actions, children }) => {
    return (
        <div className={styles.item}>
            {title ? (
                <div className={styles.title}>
                    <div className={styles.text}>{title}</div>
                    {actions ? <div className={styles.actions}>{actions?.map((action, index) => React.cloneElement(action, {
                        key: index
                    }))}</div> : null}
                </div>
            ) : null}

            {children ? <div className={styles.content}>{children}</div> : null}
        </div>
    );
};

Item.propTypes = {
    /**
     * Title of setting item
     */
    title: PropTypes.string,
    /**
     * Content of setting item
     */
    children: PropTypes.any
};
